import React from "react";
import submit from "submit-form";

export const EventsRowHeader = ({ calendarEvents }) => {
  const openIndividualEventModal = ({
    _id,
    name,
    description,
    fromDate,
    toDate,
    eventColor,
  }) => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]": "individual-event",
        eventName: name,
        eventDescription: description,
        eventFromDate: fromDate,
        eventToDate: toDate || "",
        eventColor,
        eventId: _id,
      },
    });
  };

  return (
    <div className="events-row-header">
      <span className="row-header-label">Events</span>
      {calendarEvents.map((event, index) => (
        <div
          className="event-name-label-wrapper"
          key={`event-name-label-wrapper-${index}`}
          onClick={() => openIndividualEventModal(event)}
        >
          <span className="event-name-label-text">{event.name}</span>
        </div>
      ))}
    </div>
  );
};
